import React from 'react';
import { Typography } from 'antd';
import { ToolOutlined } from '@ant-design/icons';

const { Title, Paragraph } = Typography;

const Construction = () => {
  return (
    <div
      style={{
        minHeight: '80vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        padding: '40px 20px',
        fontFamily: 'Questrial, sans-serif',
        backgroundColor: '#f9f9f9',
      }}
    >
      <ToolOutlined style={{ fontSize: 64, color: '#d4af37', marginBottom: 20 }} />
      <Title level={2} style={{ color: '#333' }}>
        Página em Construção
      </Title>
      <Paragraph style={{ fontSize: '1.1rem', maxWidth: 500, color: '#666' }}>
        Estamos trabalhando para deixar essa página pronta para você. Em breve, você poderá visualizar todas as informações por aqui!
      </Paragraph>
    </div>
  );
};

export default Construction;
